'use client';

import React from 'react';
import { Image } from '@/components/shared';

const CompanyLogos = ({ logos, className = '' }: { logos: { src: string, alt: string, width: number, height: number }[], className?: string }) => {
    return (
        <div className={`grid company-logos gap-x-16 gap-y-6 items-center ${className}`}>
            {logos.map((logo, index) => (
                <div key={index} className="flex w-full h-full justify-center items-center">
                    <Image
                        src={logo.src}
                        alt={logo.alt}
                        width={logo.width}
                        height={logo.height}
                        className='object-contain max-w-full max-h-full'
                    />
                </div>
            ))}

            <style jsx>
                {`
                    .company-logos {
                        grid-template-columns: repeat(2, 1fr);
                    }

                    @media (min-width: 768px) {
                        .company-logos {
                            grid-template-columns: repeat(${logos.length}, 1fr);
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default CompanyLogos;